import { createReducer, on } from '@ngrx/store';
import { InitialState, UsersFeatureState } from './users-state';
import { usersAdapter } from './users-adapters';
import { updateFilterModel, UserActions, UsersActions } from './users-actions';

export const usersReducer = createReducer(InitialState,
    on(UsersActions.getUsersSuccess, (state, { usersResult }): UsersFeatureState =>
        ({
          ...state,
          blsUsers: usersAdapter.setAll(usersResult.accessibleUsers, state.blsUsers),
          availableUserRoles: usersResult.availableUserRoles,
          availableUserStatuses: usersResult.availableUserStatuses,
        })),
    on(UserActions.userCreated, (state, { user }): UsersFeatureState =>
        ({ ...state, blsUsers: usersAdapter.upsertOne(user, state.blsUsers) })),
    on(UserActions.userDeleted, (state, { userId }): UsersFeatureState =>
        ({ ...state, blsUsers: usersAdapter.removeOne(userId, state.blsUsers) })),
    on(UsersActions.updateBlsUsersLoading, (state, { blsUsersLoading }): UsersFeatureState =>
        ({ ...state, blsUsersLoading })),
    on(updateFilterModel, (state, { filterModel }): UsersFeatureState =>
        ({ ...state, filterModel })),
);
